<div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
        <div class="d-flex align-items-center contact-title-wrapper">
            <img src="assets/svg/history-icon.svg" width="20" class="contact-section-icon">
            <h3 class="text-semibold contact-title">Historial de la etapa (2)</h3>
        </div>
        <div class="justify-self-end">
            <button class="action-btn primary">
                Crear nuevo presupuesto
            </button>
        </div>
    </div>
    <div class="header-stats mt-2">
        <span>2 elementos | Se actualizó hace 2 minutos</span>
    </div>

    <div class="prospectos-table mh-50 mt-3">
        <table class="stage-history-table">
            <thead>
                <tr>
                    <th>
                        <div class="th-content">
                            <span>Etapa</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Importe</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Probabilidad (%)</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Fecha de cierre</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Últ. modificación por</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Fecha últ. modificación</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Presentación propuesta</td>
                    <td>CLP 2.000.000</td>
                    <td>50%</td>
                    <td>20/08/2025</td>
                    <td>Sebastián Pérez</td>
                    <td>25/07/2025</td>
                </tr>
                <tr>
                    <td>Presentación propuesta</td>
                    <td>CLP 10.000.000</td>
                    <td>50%</td>
                    <td>24/07/2025</td>
                    <td>Sebastián Pérez</td>
                    <td>18/07/2025</td>
                </tr>
                <tr class="view-all-row">
                    <td colspan="6" class="text-center">
                        <button class="btn btn-link color-org" style="width: 125px; height: 32px; border-radius: 32px; border: 1px solid; background-color: white;" (click)="navigateToFullTable()">
                            Ver todos
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>